export default __webpack_public_path__ + "static/media/greenTick.59fce33e.jpg";